import axiosInstance from '../axios/axiosInstance';
import { Theory } from '../model/response';

export const findAllTheories = async (subjectId?: string) => {
  const { data } = await axiosInstance.get<Theory[]>('theories', { params: { subjectId } });
  return data;
};

export const findTheoryById = async (id: string) => {
  const { data } = await axiosInstance.get<Theory>(`theories/${id}`);
  return data;
};

export const toggleTheoryWebviewActive = async (id: string) => {
  await axiosInstance.patch(`theories/${id}/toggle-web-view-active`);
};
